import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import CustomPagination from "../../Utils/CustomPagination";
import { useSelector } from "react-redux";
import {
  AddCircle,
  DocumentDownload,
  Edit,
  Edit2,
  Eye,
  ProfileAdd,
  Trash,
} from "iconsax-react";

function List(props) {
  const [brandList, setbrandList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const columns = [
    {
      name: (
        <div>
          Name <br />
        </div>
      ),
      selector: (row) => row.other_name,
    },

    {
      name: "Subject",
      selector: (row) => row.subject,
    },
    {
      name: "Contact Name",
      selector: (row) => row.contact_name,
    },
    {
      name: "Contact Number",
      selector: (row) => row.contact_no,
    },
    // {
    //   name: "Employees",
    //   selector: (row) =>
    //     (row.emp_details || []).map((emp) => emp.full_name).join(", ") || "—",
    // },
    {
      name: (
        <div>
          Employees <br />
        </div>
      ),
      selector: (row) => (
        <RB.OverlayTrigger
          trigger="click"
          rootClose
          key="bottom"
          placement="bottom"
          overlay={
            <RB.Popover id={`popover-product-list`}>
              <RB.Popover.Body className="p-0">
                <ul className="list-group">
                  {row.emp_details.map((product, index) => (
                    <li key={product.id} className="list-group-item">
                      {product.full_name}
                    </li>
                  ))}
                </ul>
              </RB.Popover.Body>
            </RB.Popover>
          }
        >
          <RB.Button className="btn-flat">
            <Eye />
          </RB.Button>
        </RB.OverlayTrigger>
      ),
    },
    {
      name: "Total Amount",
      selector: (row) => row.total_amt,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <RB.Button className="btn btn-flat me-1" onClick={handleView(row)}>
            <Eye />
          </RB.Button>
          {utils.hasPermission(primaryMenuRes, "Others", "others.edit") && (
            <RB.Button
              className="btn-flat"
              title="Edit"
              onClick={handelEdit(row)}
            >
              <Edit2 />
            </RB.Button>
          )}
          {utils.hasPermission(primaryMenuRes, "Others", "others.delete") && (
            <RB.Button
              className="btn-flat ms-1"
              title="Delete"
              onClick={showDelete(row)}
            >
              <Trash />
            </RB.Button>
          )}
        </>
      ),
    },
  ];

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  useEffect(() => {
    getOthers();
  }, [page, filterText]);

  const getOthers = () => {
    utils
      .callAPI(
        "get",
        `/meeting/others/list?page=${page}&per_page=${countPerPage}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setbrandList(res);
        } else {
          setbrandList([]);
        }
      })
      .catch((err) => {
        setbrandList([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "add",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/meeting/others/delete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getOthers();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleDownload = () => {
    // quick date formatter for "YYYY-MM-DD HH:mm:ss" -> "DD-MM-YYYY"
    const formatDMY = (s) => {
      if (!s || typeof s !== "string") return "";
      const ymd = s.slice(0, 10); // "YYYY-MM-DD"
      const [y, m, d] = ymd.split("-");
      if (!y || !m || !d) return "";
      return `${d}-${m}-${y}`;
    };

    const esc = (v) => `${v ?? ""}`.replace(/"/g, '""'); // CSV-escape quotes

    utils
      .callAPI("get", `/meeting/others/list?page=0&per_page=0`)
      .then((res) => {
        const rows = Array.isArray(res?.result) ? res.result : [];
        if (!rows.length) {
          return;
        }

        // Header (exact order requested)
        const header = [
          "Requested Date",
          "Other Name",
          "State",
          "District",
          "City",
          "Subject",
          "Employee Name",
          "Reporting",
          "Total",
        ].join(",");

        const csvRows = rows.map((r) => {
          const requestedDate = formatDMY(r.createdAt);
          const otherName = r.other_name || "";
          const state = r.state_name || r.state || "";
          const district = r.district_name || r.district || "";
          const city = r.city_name || r.city || "";
          const subject = r.subject || "";
          const employees = (r.emp_details || [])
            .map((e) => e.full_name)
            .filter(Boolean)
            .join(", ");
          const rm = (r.emp_details || [])
            .map((e) => e.reporting_manager_name)
            .filter(Boolean)
            .join(", ");
          const total = r.total_amt || "";

          return [
            `"${esc(requestedDate)}"`,
            `"${esc(otherName)}"`,
            `"${esc(state)}"`,
            `"${esc(district)}"`,
            `"${esc(city)}"`,
            `"${esc(subject)}"`,
            `"${esc(employees)}"`,
            `"${esc(rm)}"`,
            `"${esc(total)}"`,
          ].join(",");
        });

        const csvContent = [header, ...csvRows].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const link = document.createElement("a");
        const ts = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", "_")
          .replace(/:/g, "-");

        link.href = URL.createObjectURL(blob);
        link.download = `Others_List.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {});
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <div className="floating-btns-holder-artisan">
            {utils.hasPermission(primaryMenuRes, "Others", "others.create") && (
              <a
                href
                className="btn btn-dark btn-circle"
                variant="dark"
                onClick={handleAddClick}
              >
                <AddCircle />
              </a>
            )}
            <a
              href
              className={`${
                brandList?.result?.length == 0 ? "disabled" : ""
              } btn btn-primary btn-circle ms-2`}
              variant="primary"
              onClick={() => handleDownload()}
            >
              <DocumentDownload />
            </a>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          {utils.hasPermission(primaryMenuRes, "Others", "others.view") && (
            <DataTable
              columns={columns}
              data={brandList.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={brandList.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              paginationComponent={() => (
                <CustomPagination
                  currentPage={page}
                  totalRows={brandList.total}
                  rowsPerPage={countPerPage}
                  onPageChange={handlePageChange}
                />
              )}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
            />
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
